// src/moduleAverages.js
//
// Единый источник структуры "8 направлений оценки" для радар-диаграммы.
// Раньше это было продублировано в ReportPreview.js и DashboardPage.js —
// и уже успело разойтись (Dashboard не знал о модуле "Мышление").
// Теперь оба файла импортируют отсюда.

export const RADAR_MODULES = [
  { name: 'Слуховое\nвосприятие', tests: ['SoundTest', 'MusicPerception', 'RhythmTest', 'PhonemicPerception', 'SoundInWord', 'SoundPosition'] },
  { name: 'Зрительное\nвосприятие', tests: ['VisionTest', 'SizeTest', 'VisionPerception'] },
  { name: 'Пространственное\nвосприятие', tests: ['SpatialDirections', 'BodyScheme', 'Puzzle', 'SeguinBoard', 'Mentalrotation'] },
  { name: 'Пассивная\nречь', tests: ['VocabularyTest', 'AnimalBabies', 'WordFormation', 'WordFormationDiminutive', 'VerbsFormation', 'SentenceComprehension', 'StorySequence', 'NegationsTest', 'MultiStepInstr'] },
  { name: 'Активная\nречь', tests: ['Antonyms', 'Generalization', 'Verbs', 'SyllableStructure'] },
  { name: 'Общая\nосведомленность', tests: ['DailyRoutine', 'Seasons', 'DaysOfWeek', 'Clocks', 'ClockBuilder'] },
  // TODO(Firouza): реальные упражнения для Артикуляции уже готовы, но ещё не
  // подключены в проект — вписать сюда их testId, когда перенесёте компоненты.
  { name: 'Артикуляция', tests: [] },
  { name: 'Мышление', tests: ['FindOddOne', 'MissingItem', 'GroupPictures', 'LifeStages', 'AnimalSorting'] },
];

/**
 * Считает среднюю успешность по каждому из 8 направлений на основе сырых
 * test_scores ({ SoundTest: 82, VisionTest: 90, ... }).
 * Используется и в ReportPreview (текущий отчёт), и в DashboardPage (история).
 */
export const calculateModuleAverages = (scores = {}) => {
  return RADAR_MODULES.map((mod) => {
    const validScores = mod.tests
      .map((t) => scores[t])
      .filter((s) => s !== undefined && !isNaN(s));
    const avg = validScores.length > 0
      ? Math.round(validScores.reduce((sum, s) => sum + s, 0) / validScores.length)
      : 0;
    return { name: mod.name, score: avg, hasData: validScores.length > 0, tests: mod.tests };
  });
};